export default "__VITE_ASSET__BjPi2XAJ__"